module.exports = __webpack_public_path__ + "img/category-management-icon1.9ff52b5a.svg";